import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${rem(50)};
`;

const Title = styled.div`
  color: ${({ theme }) => theme.color.notFound};
  font-size: ${rem(32)};
  font-weight: bold;
`;

const Spacer = styled.div`
  height: ${rem(20)};
`;

const NotFound = ({ className, icon, title, theme }) => {
  return (
    <Wrapper className={className}>
      {icon && <Icon name={icon} size="xxl" color={theme.color.notFound} />}
      {icon && title && <Spacer />}
      {title && <Title>{title}</Title>}
    </Wrapper>
  );
};

NotFound.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.shape({
    color: PropTypes.shape({}).isRequired,
  }).isRequired,
  title: PropTypes.string,
  icon: PropTypes.string,
};
NotFound.defaultProps = {
  className: '',
  title: '',
  icon: null,
};

export default withTheme(NotFound);



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js